import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'
import { Config } from '@/modules/core/config'


/**
 * Mixin multi-lenguaje
 *
 * Con funcionalidades para integrar el sistema multi-idioma de Artisan
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class I18nMixin extends Vue {

    /**
     * Referencia a la configuración de la aplicación
     */
    @State
    public config: Config

    /**
     * Indica si el panel se encuentra en modo "unico lenguaje"
     */
    public get singleLanguage (): boolean {
        return this.config.get('i18n.singleLanguage', false)
    }
}
